<template>
  <div>
    <b-row v-if="interviews.length">
      <b-col v-for="interview in interviews" :key="interview.rowKey" cols="12" md="4">
        <div class="card mb-4 position-relative p-4" :title="interview.candidateName">
          <!-- Dropdown for settings -->
          <b-dropdown
            class="position-absolute settings-dropdown"
            right
            variant="link"
            toggle-class="text-muted"
          >
            <template #button-content>
              <i class="uil uil-edit"></i>
            </template>
            <b-dropdown-item @click="editInterview(interview)">Edit</b-dropdown-item>
            <b-dropdown-item @click="deleteInterview(interview)" class="text-danger">Delete</b-dropdown-item>
          </b-dropdown>

          <!-- Card content -->
          <b-card-text>
            <strong>Position:</strong> {{ interview.position }}
            <br>
            <strong>Company:</strong> {{ interview.companyName }}
            <br>
            <strong>Meeting Type:</strong> {{ interview.meetingType }}
            <br>
            <strong>Interview Date:</strong> {{ formatDateWithTime(interview.interviewDate) }}
            <br>
            <strong>Status: </strong>
            <b-badge :variant="statusVariant(interview.status)" class="status-chip p-2">
              {{ interview.status }}
            </b-badge>
          </b-card-text>

          <!-- Join button -->
          <div class="text-right mt-4">
            <b-button
              variant="primary"
              :href="interview.meetingLink"
              target="_blank"
              v-if="interview.meetingLink"
              class="join-btn"
            >
              Join
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-5 col-8">
          <div class="text-center">
            <div>
              <img src="../../../../assets/images/not-found.png" alt class="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <h3 class="mt-3">No Interviews.</h3>
          <p class="text-muted mb-5">
            No scheduled interviews.
            <br />There are no scheduled interviews, or you have not been assigned any interviews."
          </p>
        </div>
      </div>
    </div>

    <!-- Create Interview Button -->
    <!-- <b-button variant="success" @click="createInterview" class="mt-3">
      Create Interview
    </b-button> -->

    <CreateInterviewModal
      :showCreateModal="showCreateModal"
      @update:showCreateModal="showCreateModal = $event"
      @createInterview="addInterview"
    />
  </div>
</template>

<script>
import CreateInterviewModal from './CreateInterviewModal.vue';

export default {
  components: {
    CreateInterviewModal,
  },
  data() {
    return {
      interviews: [],
      showCreateModal: false,
    };
  },
  methods: {
    createInterview() {
      this.showCreateModal = true;
    },
    addInterview(newInterview) {
      this.interviews.push(newInterview);
    },
    formatDateWithTime(dateTime) {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // ensures AM/PM format
        timeZone: 'Asia/Manila', // set your timezone here if needed
      };
      return new Date(dateTime).toLocaleString('en-US', options);
    },
    statusVariant(status) {
      switch (status) {
        case 'Scheduled':
          return 'primary';
        case 'Completed':
          return 'success';
        case 'Cancelled':
          return 'danger';
        default:
          return 'secondary';
      }
    },
    editInterview(interview) {
      console.log('Editing interview:', interview);
    },
    deleteInterview(interview) {
      this.interviews = this.interviews.filter(i => i !== interview);
    },
    async fetchData() {
        this.interviews = [];
        await this.$store.dispatch('interview/pagination')
        .then(res => {
          let data = res.data

          data.forEach((interview) => {
            const cand = interview.candidate_id;
            const name =
              cand && (cand.first_name || cand.last_name)
                ? `${cand.first_name || ''} ${cand.last_name || ''}`.trim()
                : 'Candidate';
            this.interviews.push({
              rowKey: String(interview._id),
              candidateName: name,
              companyName: interview.application_id.job_id.company_id.name,
              meetingLink: interview.application_id.meetingLink,
              meetingType: interview.application_id.meetingType,
              interviewDate: interview.date,
              position: interview.application_id.job_id.title,
              status: interview.application_id.sub_status,
            });
          });
        })
      }
  },
  mounted(){
    this.fetchData();
  }
};
</script>

<style scoped>
/* Positioning for the settings dropdown */
.settings-dropdown {
  top: 10px;
  right: 10px;
  z-index: 1;
}

/* Styling for the Join button */
.join-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

/* Additional styling for the card */
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}
</style>
